module.exports = __webpack_public_path__ + "img/section1SwiperTab2.d6e54659.png";